(function () {
  'use strict';

  document.querySelectorAll('[data-tabs-showcase]').forEach(function (wrapper) {
    var tablist = wrapper.querySelector('[role="tablist"]');
    if (!tablist) return;

    var tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    var panels = tabs.map(function (tab) {
      return wrapper.querySelector('#' + tab.getAttribute('aria-controls'));
    });

    function activateTab(tab) {
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
        t.classList.remove('tabs-showcase__tab--active');
        t.setAttribute('tabindex', '-1');
      });

      panels.forEach(function (p) {
        if (p) p.hidden = true;
      });

      tab.setAttribute('aria-selected', 'true');
      tab.classList.add('tabs-showcase__tab--active');
      tab.setAttribute('tabindex', '0');

      var panel = wrapper.querySelector('#' + tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = false;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    tablist.addEventListener('keydown', function (e) {
      var index = tabs.indexOf(document.activeElement);
      if (index === -1) return;

      var newIndex;
      switch (e.key) {
        case 'ArrowRight':
          newIndex = (index + 1) % tabs.length;
          break;
        case 'ArrowLeft':
          newIndex = (index - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          newIndex = 0;
          break;
        case 'End':
          newIndex = tabs.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      activateTab(tabs[newIndex]);
      tabs[newIndex].focus();
    });
  });
})();
